import {
  Search,
  FileDown,
  Layers,
  FileOutput,
  FileText,
  List,
  BookOpen,
  Hash,
  Shield,
  Copy,
  ChevronRight,
} from "lucide-react";

const workflow = [
  { icon: Search, label: "Detect Appeal", desc: "Monitor court filings" },
  { icon: FileDown, label: "Pull Docket", desc: "From NYSCEF system" },
  { icon: Layers, label: "Assemble + Format", desc: "Auto-generate docs" },
  { icon: FileOutput, label: "Output PDF", desc: "Court-ready package" },
];

const features = [
  { icon: FileText, label: "Cover Page" },
  { icon: List, label: "Table of Contents" },
  { icon: BookOpen, label: "CPLR \u00A7 5531 Statement" },
  { icon: Hash, label: "Paginated Record" },
  { icon: Shield, label: "Full, Partial & Sealed" },
  { icon: Copy, label: "Multi-volume Support" },
];

export default function ProductSlide() {
  return (
    <div
      className="h-full w-full flex flex-col p-7 sm:p-10 lg:p-12"
      data-testid="slide-product-content"
    >
      <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
        THE PRODUCT
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-6 leading-tight">
        End-to-end automation for appellate record preparation
      </h1>

      <div className="grid grid-cols-2 md:flex md:items-center gap-2 sm:gap-3 mb-6">
        {workflow.map((step, i) => (
          <div key={i} className="bg-blue-50 rounded-lg p-3 sm:p-4 text-center border border-blue-100 md:flex-1">
            <step.icon className="h-5 w-5 text-blue-600 mx-auto mb-1.5" />
            <div className="text-sm font-semibold text-slate-900 font-heading">
              {step.label}
            </div>
            <div className="text-[11px] sm:text-xs text-slate-500 font-body mt-0.5">
              {step.desc}
            </div>
          </div>
        ))}
      </div>

      <div className="flex-1 min-h-0">
        <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-slate-400 mb-3 font-body">
          Automatically Generates
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 sm:gap-3">
          {features.map((f, i) => (
            <div
              key={i}
              className="flex items-center gap-2 bg-slate-50 rounded-lg p-2.5 sm:p-3 border border-slate-100"
            >
              <f.icon className="h-3.5 w-3.5 text-blue-600 shrink-0" />
              <span className="text-sm text-slate-700 font-medium font-body">
                {f.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      <p className="text-sm text-slate-400 font-body mt-3">
        Outputs a court-ready PDF package directly from e-filing systems like
        NYSCEF
      </p>
    </div>
  );
}
